exports.value = "v2.5.2-hotfix.5";